<div class="row">
  <div class="col-12 col-md-6">
    <h4 translate>{{ checkout.extra._flow.isReturnOrder ? 'PICKUP_ADDRESS' : 'DELIVERY_ADDRESS' }}</h4>
    <div class="form-group">
      <label for="ordlevadr1" class="control-label" translate>OH_ORDLEVADR1</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="ordlevadr1"
        [value]="checkout.extra.procargs.ordlevadr1 || ''"
        readonly
      />
    </div>
    <div class="form-group">
      <label for="ordlevadr3" class="control-label" translate>OH_ORDLEVADR3</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="ordlevadr3"
        [value]="checkout.extra.procargs.ordlevadr3 || ''"
        readonly
      />
    </div>
    <div class="form-group">
      <label for="ordlevadr2" class="control-label" translate>OH_ORDLEVADR2</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="ordlevadr2"
        [value]="checkout.extra.procargs.ordlevadr2 || ''"
        readonly
      />
    </div>

    <div class="form-group">
      <label for="ordlevadr4" class="control-label" translate>OH_ORDLEVADR4</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="ordlevadr4"
        [value]="checkout.extra.procargs.ordlevadr4 || ''"
        readonly
      />
    </div>
    <lib-meta-select-input
      [(ngModel)]="checkout.extra.procargs.ordlevadrlandskod"
      table="xr"
      metaId="landskod"
      metaDisplay="land"
      [disabled]="true"
    >
    </lib-meta-select-input>
    <!-- <div class="form-group">
      <label for="oh.edit" translate>MESSAGE</label>
      <textarea name="oh.edit" id="oh.edit" class="form-control form-control-sm" [value]="checkout.extra.oh.edit" readonly></textarea>
    </div> -->
  </div>
  <div class="col-12 col-md-6" *ngIf="customer && !checkout.extra._flow.isReturnOrder">
    <h4 translate>INVOICE_ADDRESS</h4>
    <div class="form-group">
      <label for="billingFtgnr" class="control-label" translate>CUSTOMER_ID</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="billingFtgnr"
        [value]="customerBilling.ftgnr || ''"
        readonly
      />
    </div>
    <div class="form-group">
      <label for="billingFtgnamn" class="control-label" translate>FTGNAMN</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="billingFtgnamn"
        [value]="customerBilling.ftgnamn || ''"
        readonly
      />
    </div>
    <div class="form-group">
      <label for="billingFtgpostadr2" class="control-label" translate>FTGPOSTADR2</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="billingFtgpostadr2"
        [value]="customerBilling.ftgpostadr2 || ''"
        readonly
      />
    </div>
    <div class="form-group">
      <label for="billingFtgpostnr" class="control-label" translate>FTGPOSTNR</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="billingFtgpostnr"
        [value]="customerBilling.ftgpostnr || ''"
        readonly
      />
    </div>
    <div class="form-group">
      <label for="billingFtgpostadr3" class="control-label" translate>FTGPOSTADR3</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="billingFtgpostadr3"
        [value]="customerBilling.ftgpostadr3 || ''"
        readonly
      />
    </div>
    <lib-meta-select-input
      [(ngModel)]="customerBilling.landskod"
      table="xr"
      metaId="landskod"
      metaDisplay="land"
      [disabled]="true"
    >
    </lib-meta-select-input>
  </div>
</div>

<h4 *ngIf="!checkout.extra._flow.isReturnOrder" translate>CONDITIONS</h4>
<div *ngIf="!checkout.extra._flow.isReturnOrder" class="row">
  <div class="col-12 col-md-6">
    <lib-meta-select-input
      [(ngModel)]="checkout.extra.procargs.levsattkod"
      table="x2f"
      metaId="levsattkod"
      metaDisplay="levsattbeskr"
      [disabled]="true"
    >
    </lib-meta-select-input>
    <lib-meta-select-input
      [(ngModel)]="checkout.extra.procargs.levvillkkod"
      table="x2e"
      metaId="levvillkkod"
      metaDisplay="levvillkbeskr"
      [disabled]="true"
    >
    </lib-meta-select-input>
  </div>
  <div class="col-12 col-md-6">
    <lib-meta-select-input
      [(ngModel)]="checkout.extra.oh.betkod"
      table="x2"
      metaId="betkod"
      metaDisplay="betvillbeskr"
      [disabled]="true"
    >
    </lib-meta-select-input>
    <lib-meta-select-input
      [(ngModel)]="checkout.extra.procargs.saljare"
      table="salj"
      metaId="saljare"
      metaDisplay="saljarenamn"
      [disabled]="true"
    >
    </lib-meta-select-input>
  </div>
</div>

<div *ngIf="productsMap && pricesMap">
  <h4 translate>ROWS</h4>
  <table class="table table-striped">
    <thead>
      <tr>
        <th translate>PRODUCT_ID</th>
        <th translate>NAME</th>
        <th *ngIf="!checkout.extra._flow.isReturnOrder" translate>ESTIMATED_DELIVERY_DATE</th>
        <th *ngIf="!!checkout.extra._flow.isReturnOrder" translate>DESIRED_PICKUP_DATE</th>
        <th translate>QUANTITY</th>
        <th *ngIf="!isReturNoPrice" translate>UNIT_PRICE</th>
        <th *ngIf="sales && !isReturNoPrice" class="d-table-cell" translate>DISCOUNT</th>
        <th *ngIf="!isReturNoPrice" translate>TOTAL</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of checkout.rows">
        <td>{{ row.id }}</td>
        <td>{{ productsMap[row.id].name }}</td>
        <td *ngIf="!checkout.extra._flow.isReturnOrder">
          <span *ngIf="row.extra.orp && row.extra.orp.ordberlevdat; else orderHeadDate">{{
            row.extra.orp.ordberlevdat | date: 'yyyy-MM-dd'
          }}</span>
          <ng-template #orderHeadDate>
            <span *ngIf="checkout.extra.oh.ordberlevdat; else defaultDate">{{
              checkout.extra.oh.ordberlevdat | date: 'yyyy-MM-dd'
            }}</span>
          </ng-template>
          <ng-template #defaultDate>{{ today | date: 'yyyy-MM-dd' }}</ng-template>
        </td>
        <td *ngIf="!!checkout.extra._flow.isReturnOrder">
          <span *ngIf="checkout.extra.unifaunReturn && checkout.extra.unifaunReturn.ordreturdatum">{{
            checkout.extra.unifaunReturn.ordreturdatum | date: 'yyyy-MM-dd'
          }}</span>
          <ng-template #orderHeadDate>
            <span *ngIf="checkout.extra.unifaunReturn.ordreturdatum">{{
              checkout.extra.unifaunReturn.ordreturdatum | date: 'yyyy-MM-dd'
            }}</span>
          </ng-template>
          <ng-template #defaultDate>{{ today | date: 'yyyy-MM-dd' }}</ng-template>
        </td>
        <td>
          <span *ngIf="!!checkout.extra._flow.isReturnOrder">-</span>
          {{ row.quantity }}
        </td>
        <td *ngIf="!isReturNoPrice">
          <span *ngIf="!!checkout.extra._flow.isReturnOrder">-</span>
          <span *ngIf="pricesMap">
            {{
              pricesMap[row.id].cartRowUnitPrice.value | gungCurrency: pricesMap[row.id].cartRowUnitPrice.currencyCode
            }}
          </span>
        </td>
        <td *ngIf="sales && !isReturNoPrice" class="d-table-cell">
          <span *ngIf="pricesMap && pricesMap[row.id].cartRowDiscountPercent"
            >{{ pricesMap[row.id].cartRowDiscountPercent }} %</span
          >
        </td>
        <td *ngIf="!isReturNoPrice">
          <span *ngIf="!!checkout.extra._flow.isReturnOrder">-</span>
          <span *ngIf="pricesMap">
            {{
              pricesMap[row.id].cartRowTotalPriceInclRowDiscount.value
                | gungCurrency: pricesMap[row.id].cartRowTotalPriceInclRowDiscount.currencyCode
            }}</span
          >
        </td>
        <!-- <td *ngIf="pricesMap">{{pricesMap[row.id].customerNetPrice.value}} {{pricesMap[row.id].customerNetPrice.currencyCode}}</td> -->
      </tr>
    </tbody>
  </table>
</div>
